import { GlobalConstants } from "../data/GlobalConstants";
import { handleResponse } from "../util/functions";
import { getToken } from "../helpers/helperJWT";
import { loaderService } from "./loaderService";

const url = GlobalConstants.urlApi;

export const evaluacionSolicitudServices = {
    getClaseSolicitud,
    getActivoById,
    getActivoAsignado,
    getComentarioByImg,
    getDataGestionActivos,
    getHistoricoSolicitud,
    getDisponibles,
    getCausales,
    getTransportadores,
    getTransporteAsignado,
    getHistoricoVentas,
    setAsignacion,
    setTransporte,
    getTipoGrupSolicitud,
    imprimirCierre,
    getDataSolicitudTraslado,
    validarEstadoSolicitudRetiro,
    getIndicadoresSolicitudes
};

async function getClaseSolicitud(data) {
    loaderService.showLoader({ label: "Cargando..." });

    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': getToken()
        },
        body: JSON.stringify({data})
    };

    return fetch(`${url}/evaluacionSolicitudes/getClaseSolicitud`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

function getActivoById(codigo) {
    loaderService.showLoader({ label: "Cargando..." });

    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': getToken()
        },
        body: JSON.stringify({codigo})
    };

    return fetch(`${url}/evaluacionSolicitudes/getActivoById`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

function getActivoAsignado(codigo) {
    loaderService.showLoader({ label: "Cargando..." });

    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': getToken()
        },
        body: JSON.stringify({codigo})
    };

    return fetch(`${url}/evaluacionSolicitudes/getActivoAsignado`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

function getComentarioByImg(img) {
    loaderService.showLoader({ label: "Cargando..." });

    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': getToken()
        },
        body: JSON.stringify({img})
    };

    return fetch(`${url}/evaluacionSolicitudes/getComentarioByImg`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

async function getDataGestionActivos(data) {
    loaderService.showLoader({ label: "Cargando..." });

    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': getToken()
        },
        body: JSON.stringify({data})
    };

    return fetch(`${url}/evaluacionSolicitudes/getDataGestionActivos`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

async function getHistoricoSolicitud(codigo) {
    loaderService.showLoader({ label: "Cargando..." });

    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': getToken()
        },
        body: JSON.stringify({codigo})
    };

    return fetch(`${url}/evaluacionSolicitudes/getHistoricoSolicitud`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

function getDisponibles(data) {
    loaderService.showLoader({ label: "Cargando..." });

    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': getToken()
        },
        body: JSON.stringify({data})
    };

    return fetch(`${url}/evaluacionSolicitudes/getDisponibles`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

function getCausales() {
    loaderService.showLoader({ label: "Cargando..." });

    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': getToken()
        },
        body: JSON.stringify({})
    };

    return fetch(`${url}/evaluacionSolicitudes/getCausales`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

function getTransportadores(data) {
    // loaderService.showLoader({ label: "Cargando..." });

    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': getToken()
        },
        body: JSON.stringify({data})
    };

    return fetch(`${url}/evaluacionSolicitudes/getTransportadores`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

function getTransporteAsignado(codigo) {
    // loaderService.showLoader({ label: "Cargando..." });

    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': getToken()
        },
        body: JSON.stringify({codigo})
    };

    return fetch(`${url}/evaluacionSolicitudes/getTransporteAsignado`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

function getHistoricoVentas(data) {
    loaderService.showLoader({ label: "Cargando..." });

    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': getToken()
        },
        body: JSON.stringify({data})
    };

    return fetch(`${url}/evaluacionSolicitudes/getHistoricoVentas`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

function setAsignacion(data) {
    loaderService.showLoader({ label: "Cargando..." });

    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': getToken()
        },
        body: JSON.stringify({data})
    };

    return fetch(`${url}/evaluacionSolicitudes/setAsignacion`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

function setTransporte(data) {
    loaderService.showLoader({ label: "Cargando..." });

    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': getToken()
        },
        body: JSON.stringify({data})
    };

    return fetch(`${url}/evaluacionSolicitudes/setTransporte`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

function getTipoGrupSolicitud() {
    loaderService.showLoader({ label: "Cargando..." });

    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': getToken()
        },
        body: JSON.stringify()
    };

    return fetch(`${url}/evaluacionSolicitudes/getTipoGrupSolicitud`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

function imprimirCierre(data) {
    loaderService.showLoader({ label: "Cargando..." });

    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': getToken()
        },
        body: JSON.stringify({data})
    };

    return fetch(`${url}/evaluacionSolicitudes/imprimirCierre`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

function getDataSolicitudTraslado(codigo,fecha) {
    loaderService.showLoader({ label: "Cargando..." });

    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': getToken()
        },
        body: JSON.stringify({codigo,fecha})
    };

    return fetch(`${url}/evaluacionSolicitudes/getDataTraslado`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

function validarEstadoSolicitudRetiro(codigo,fecha) {
    loaderService.showLoader({ label: "Cargando..." });

    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': getToken()
        },
        body: JSON.stringify({codigo,fecha})
    };

    return fetch(`${url}/evaluacionSolicitudes/validarEstadoSolicitudRetiro`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

function getIndicadoresSolicitudes(data){
    loaderService.showLoader({label: 'Cargando...'})
  
    const requestOptions = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': getToken()
      },
      body: JSON.stringify(data)
    }
  
    return fetch(`${url}/evaluacionSolicitudes/getIndicadoresSolicitudes`, requestOptions)
      .then(handleResponse)
      .then( response => {
        return response;
      })
  }



